<template>
  <el-dialog class="close-private"
             :visible.sync="show"
             :title="$t('privateNetInstance.closeTitle')"
             :close-on-click-modal="false"
             :before-close="handleClose">
    <p>{{ $t('privateNetInstance.closeTip', [name]) }}</p>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelClose">{{ $t('privateNetInstance.cancel') }}</el-button>
      <el-button @click="sureClose" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "Close",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      instanceId: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      region: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        show: false
      }
    },
    methods: {
      handleClose() {
        this.show = false;
        this.$emit('update:visible', false);
      },
      cancelClose() {
        this.handleClose();
      },
      sureClose() {
        this.closeInstance();
      },
      closeInstance() {
        const params = {
          instanceId: this.instanceId,
          region: this.region,
          clientToken: Normal.getClientToken(),
        };
        Ajax.put('/api/cps/stopInstance', params)
          .then()
          .catch()
          .finally(() => {
            this.handleClose();
            this.$emit('refresh')
          });
      }
    },
    watch: {
      visible(newVal) {
        this.show = newVal;
      }
    }
  }
</script>

<style lang="scss">
  .close-private{

  }
</style>




// WEBPACK FOOTER //
// src/components/privateNetInstance/operates/Close.vue